import { render, staticRenderFns } from "./CertificatesTableRow.vue?vue&type=template&id=6e92fe7e&scoped=true&"
import script from "./CertificatesTableRow.vue?vue&type=script&lang=js&"
export * from "./CertificatesTableRow.vue?vue&type=script&lang=js&"
import style0 from "./CertificatesTableRow.vue?vue&type=style&index=0&id=6e92fe7e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e92fe7e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCheckbox,VCol,VRow})
